import { c as _c } from "react/compiler-runtime";
import type { Outcome } from '@svs/nova-poolbetting/schema/coupon';
import type { MultiForecast, MultiForecastOutcome } from '@svs/nova-poolbetting/schema/forecast';
import type { Participant } from '@svs/nova-poolbetting/schema/sport';
import { createBrandedData } from '@svs/nova-poolbetting/schema/type-utils';
import { CouponEventParticipants, CouponOutcomePrediction } from '@svs/nova-poolbetting/ui/Coupon';
import { TipsenLink } from '@svs/nova-poolbetting/ui/TipsenLink';
import type { ReactNode } from 'react';
type MultiForecastProps = {
  multiForecast: MultiForecast[];
  currentCorrectResult: Outcome | undefined;
  selectedOutcome?: MultiForecastOutcome;
  participants?: (Participant | undefined)[];
};

/**
 * MultiForecast component.
 *
 * @param root0 props
 * @param root0.multiForecast multi forecast data
 * @param root0.currentCorrectResult current correct result for forecast
 * @param root0.selectedOutcome user selected outcome for multi forecast
 * @param root0.participants participants for the forecast event
 * @returns Component that handles multi forecast display.
 */
export function MultiForecast(t0) {
  const $ = _c(16);
  const {
    multiForecast,
    selectedOutcome,
    currentCorrectResult,
    participants
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-md [grid-area:title]">Utdelning vid olika utfall</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `Event ${multiForecast[0]?.eventNumber}`;
  let t3;
  if ($[1] !== participants || $[2] !== t2) {
    t3 = <CouponEventParticipants className="flex justify-center text-sm" participants={participants} eventDescription={t2}>-</CouponEventParticipants>;
    $[1] = participants;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== currentCorrectResult || $[5] !== multiForecast || $[6] !== selectedOutcome) {
    let t5;
    if ($[8] !== currentCorrectResult || $[9] !== selectedOutcome) {
      t5 = (forecast, index) => <TipsenLink key={forecast.outcome} href={{
        query: {
          multiForecastOutcome: createBrandedData(index)
        }
      }} queriesToKeep="ALL" scroll={false}><CouponOutcomePrediction index={index} outcome={forecast.outcome} status={currentCorrectResult === index ? "correct" : "default"} buttonSize="md" eventNumber={forecast.eventNumber} isSelected={selectedOutcome === undefined ? currentCorrectResult === index : selectedOutcome === index} /></TipsenLink>;
      $[8] = currentCorrectResult;
      $[9] = selectedOutcome;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = multiForecast.map(t5);
    $[4] = currentCorrectResult;
    $[5] = multiForecast;
    $[6] = selectedOutcome;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <div className="flex justify-center gap-2 [grid-area:outcomes]">{t4}</div>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <div className="bg-primary-fg-muted text-layer-fg grid w-full gap-2 p-4 text-center font-medium [grid-template-areas:'title''description''outcomes']">{t1}{t3}{t5}</div>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}